import React, { FC, useEffect, useState } from 'react';
import { EmptyText } from '../EmptyText';
import { NonEditableText } from '../NonEditableText';
import EditableFieldWrapper from '../EditableFieldWrapper';
import TextNumber from './components/TextNumber';
import EditableNumberForm from './components/EditableNumberForm';
import { TEditableNumberProps } from '../EditableFields.type';

export const EditableNumber: FC<TEditableNumberProps> = (props) => {
  const {
    fontLevel,
    onEdit,
    isLoading,
    numberValue,
    error,
    icon,
    minMedia,
    fontWeight,
    placeholder,
    emptyText,
    showTextValue,
    color,
    canEdit,
    canRemove,
  } = props;
  const [value, setValue] = useState(numberValue);
  const [isEditable, setIsEditable] = useState(false);

  const onChange = (newValue: string) => {
    setIsEditable(false);
    if (!canRemove && !newValue) {
      setValue(numberValue);
      return;
    }
    if (numberValue !== newValue || error) {
      setValue(newValue);
      onEdit(newValue);
    }
  };

  useEffect(() => {
    if (error) {
      setValue(numberValue);
    }
  }, [error]);

  useEffect(() => {
    setValue(numberValue);
  }, [numberValue]);

  if (canEdit) {
    return (
      <EditableFieldWrapper
        canEdit={canEdit}
        isEditable={isEditable}
        icon={icon}
        color={color}
        minMedia={minMedia}
        isLoading={isLoading}
        error={error}
      >
        {isEditable ? (
          <EditableNumberForm
            onEdit={onChange}
            placeholder={placeholder}
            setIsEditable={setIsEditable}
            setValue={setValue}
            numberValue={numberValue}
          />
        ) : (
          <>
            {value ? (
              <TextNumber
                setIsEditable={setIsEditable}
                numberValueString={showTextValue}
                fontWeight={fontWeight}
                fontLevel={fontLevel}
                color={color}
              />
            ) : (
              <EmptyText
                emptyText={emptyText}
                fontWeight={fontWeight}
                fontLevel={fontLevel}
                onClick={() => setIsEditable(true)}
              />
            )}
          </>
        )}
      </EditableFieldWrapper>
    );
  }

  return (
    <NonEditableText
      value={value}
      icon={icon}
      fontWeight={fontWeight}
      fontLevel={fontLevel}
    />
  );
};

export default EditableNumber;
